"use client"

import React from "react"

type PhaseIconProps = {
  type: "plan" | "build" | "run"
  size?: "sm" | "md" | "lg"
  className?: string
}

const iconSizes = {
  sm: "w-5 h-5",
  md: "w-8 h-8",
  lg: "w-12 h-12",
}

export default function PhaseIcon({
  type,
  size = "md",
  className = "",
}: PhaseIconProps) {
  const sizeClasses = iconSizes[size]

  switch (type) {
    case "plan":
      return (
        <svg
          className={`${sizeClasses} ${className}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            strokeWidth="2"
          />
          <path
            d="M12 3V5"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M12 19V21"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M3 12H5"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M19 12H21"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M12 12L16 16"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )
    case "build":
      return (
        <svg
          className={`${sizeClasses} ${className}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 22H22"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <rect
            x="4"
            y="12"
            width="4"
            height="10"
            strokeWidth="2"
          />
          <rect
            x="10"
            y="6"
            width="4"
            height="16"
            strokeWidth="2"
          />
          <rect
            x="16"
            y="9"
            width="4"
            height="13"
            strokeWidth="2"
          />
        </svg>
      )
    case "run":
      return (
        <svg
          className={`${sizeClasses} ${className}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L5 12H10L8 22L20 10H13L12 2Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    default:
      return null
  }
}
